import { InvoiceState, MarkInvoiceAsPastDueCommand } from "../../GeneratedClients/FreeBillApi"
import { apiService } from "../../apiService"

const updateInvoiceState = async(userId: string | undefined) => {
  try {
    const {data: invoices} = await apiService.InvoicesApi.getInvoices({pageSize:100, invoiceStateEq: [InvoiceState.Pending]})
    invoices.forEach(async invoice => {
      if(invoice.dueDate) {
        const markInvoiceAsPastDueCommand: MarkInvoiceAsPastDueCommand = {id: invoice.id, userId: userId}
        const todayStartOfDay = new Date(new Date().setUTCHours(0,0,0,0))
        const dueDate = new Date(invoice.dueDate)
        todayStartOfDay > dueDate && await apiService.InvoicesApi.markInvoiceAsPastDue({markInvoiceAsPastDueCommand: markInvoiceAsPastDueCommand, id: invoice.id!})  
      }
    })
  } catch (error) {
    console.log(error)
  }
}

export default updateInvoiceState